"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_FIELDS_TYPES = exports.TEMPLATE_TYPES = exports.EXTERNAL_SOURCES = void 0;
exports.EXTERNAL_SOURCES = Object.freeze({
    HELLOSIGN: 'hellosign'
});
exports.TEMPLATE_TYPES = Object.freeze({
    LEASE: 'lease',
    RENEWAL: 'renewal',
    WATER_SERVICE_TRANSFER: 'water_service_transfer'
});
exports.CUSTOM_FIELDS_TYPES = Object.freeze({
    STANDARD_LEASE: 'standard_lease',
    STANDARD_RENEWAL: 'standard_renewal',
    KCPOA_LEASE: 'kcpoa_lease',
    SANDALWOOD_LEASE: 'sandalwood_lease',
    SANDALWOOD_RENEWAL: 'sandalwood_renewal'
});
